import { dangerColors, TenantPalette } from "./tokens";

export const buildDarkPalette = (p: TenantPalette) => ({
  mode: "dark" as const,
  accentText: p.primary[300],
  highlight: p.accent[500],
  brand: { primary: p.primary, accent: p.accent, success: p.success, warning: p.warning },
  primary: {
    main: p.dark.background,
    light: p.accent[300],
    dark: p.primary[500],
    contrastText: p.dark.text,
  },
  secondary: {
    main: p.dark.surface,
    contrastText: p.dark.text,
  },
  background: {
    default: p.dark.background,
    paper: p.dark.surface,
  },
  text: {
    primary: p.dark.text,
    secondary: "rgba(255, 255, 255, 0.7)",
  },
  divider: p.dark.border,
  warning: {
    main: p.warning[500],
    dark: p.warning[600],
    light: p.warning[400],
    contrastText: "#fff",
  },
  error: {
    main: dangerColors.main,
    light: "#F26969",
    dark: dangerColors.hover,
    contrastText: "#fff",
  },
  success: {
    main: p.success[500],
    light: p.success[400],
    dark: p.success[600],
    contrastText: "rgba(0,0,0,0.87)",
  },
  info: {
    main: p.accent[500],
    light: p.accent[300],
    dark: p.accent[700],
    contrastText: "#fff",
  },
});
